<ng-container *tuiLet="topCities$ | async as topCities">
  <ng-container *tuiLet="searchCities$ | async as searchCities">
    <button
      tuiButton
      type="button"
      class="search-cities-button"
      [appearance]="'action-grayscale'"
      [size]="size"
      [tuiDropdown]="content"
      [(tuiDropdownOpen)]="open"
      [iconEnd]="'@tui.chevron-down'"
    >
      {{ selectedCityLabel }}

      <ng-template #content>
        <div class="content">
          <app-search
            class="search"
            [(searchQuery)]="searchQuery"
            (searchQueryChange)="onSearchChange($event)"
          ></app-search>

          <tui-data-list>
            <tui-opt-group
              *ngIf="searchCities || topCities as items; else skeletonTmp"
              [label]="
                searchCities
                  ? ('components.searchCitiesInput.labels.searchResults' | translate)
                  : ('components.searchCitiesInput.labels.topCities' | translate)
              "
            >
              <button *ngFor="let item of items" tuiOption type="button" (click)="setValue(item)">
                <render-city-row [city]="item"></render-city-row>
                <app-icon *ngIf="item.cityId === value.cityId" [src]="'@tui.check'" [size]="'16px'"></app-icon>
              </button>
            </tui-opt-group>
          </tui-data-list>
        </div>
      </ng-template>
    </button>
  </ng-container>
</ng-container>

<ng-template #skeletonTmp>
  <app-skeleton-wrapper [loading]="true"></app-skeleton-wrapper>
</ng-template>
